<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="用户ID" prop="userId">
                <a-input v-model="queryParam.userId" placeholder="请输入用户ID" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="用户昵称" prop="nickname">
                <a-input v-model="queryParam.nickname" placeholder="请输入用户昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" placeholder="请输入手机号" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="设备序列号" prop="deviceSn">
                  <a-input v-model="queryParam.deviceSn" placeholder="请输入设备序列号" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="蓝牙MAC地址" prop="bluetoothMac">
                  <a-input v-model="queryParam.bluetoothMac" placeholder="请输入蓝牙MAC地址" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="设备名称" prop="deviceName">
                  <a-input v-model="queryParam.deviceName" placeholder="请输入设备名称" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="绑定时间" prop="bindTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.bindTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 24 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['mibo:device:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['mibo:device:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['mibo:device:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <live-preview-modal ref="livePreviewModal" />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="bindStatus" slot-scope="text, record">
          <a-switch
            :checked="record.bindStatus == 1 || record.bindStatus == '1'"
            @change="(checked) => handleBindStatusChange(record, checked)"
          />
        </span>
        <span slot="onlineStatus" slot-scope="text, record">
          <a-tag :color="(record.onlineStatus == 1 || record.onlineStatus == '1') ? 'green' : 'default'">
            {{ (record.onlineStatus == 1 || record.onlineStatus == '1') ? '在线' : '离线' }}
          </a-tag>
        </span>
        <span slot="bindTime" slot-scope="text, record">
          {{ parseTime(record.bindTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.livePreviewModal.open(record)" v-hasPermi="['mibo:device:query']">
            <a-icon type="video-camera" />实时预览
          </a>
          <a-divider type="vertical" v-hasPermi="['mibo:device:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['mibo:device:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['mibo:device:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['mibo:device:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageDevice, listDevice, delDevice, updateDevice } from '@/api/mibo/device'
import CreateForm from './modules/CreateForm'
import LivePreviewModal from './modules/LivePreviewModal'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Device',
  components: {
    CreateForm,
    LivePreviewModal
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: null,
        nickname: null,
        mobile: null,
        deviceTypeId: null,
        deviceSn: null,
        bluetoothMac: null,
        deviceName: null,
        ownerPetId: null,
        bindStatus: null,
        onlineStatus: null,
        bindTime: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '用户ID',
          dataIndex: 'userId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '用户昵称',
          dataIndex: 'nickname',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '手机号',
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备序列号',
          dataIndex: 'deviceSn',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '蓝牙MAC地址',
          dataIndex: 'bluetoothMac',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '设备名称',
          dataIndex: 'deviceName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '绑定状态',
          dataIndex: 'bindStatus',
          scopedSlots: { customRender: 'bindStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '在线状态',
          dataIndex: 'onlineStatus',
          scopedSlots: { customRender: 'onlineStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '绑定时间',
          dataIndex: 'bindTime',
          scopedSlots: { customRender: 'bindTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 220,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询用户设备绑定列表 */
    getList () {
      this.loading = true
     pageDevice(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        deviceTypeId: undefined,
        deviceSn: undefined,
        bluetoothMac: undefined,
        deviceName: undefined,
        ownerPetId: undefined,
        bindStatus: undefined,
        onlineStatus: undefined,
        bindTime: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delDevice(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('mibo/user-device/export', {
            ...that.queryParam
          }, `用户设备绑定_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 绑定状态开关变更 */
    handleBindStatusChange (record, checked) {
      const bindStatus = checked ? 1 : 0
      const updateData = {
        ...record,
        bindStatus
      }
      updateDevice(updateData).then(() => {
        record.bindStatus = bindStatus
        this.$message.success('绑定状态更新成功')
        this.getList()
      }).catch(() => {
        this.$message.error('绑定状态更新失败')
      })
    },
    /** 排序值变更 */
    handleSortChange (record, value, fieldName) {
      if (value === null || value === undefined) {
        return
      }
      const updateData = {
        ...record,
        [fieldName]: value
      }
      updateDevice(updateData).then(() => {
        record[fieldName] = value
        this.$message.success('排序更新成功')
        this.getList()
      }).catch(() => {
        this.$message.error('排序更新失败')
      })
    }
  }
}
</script>
